(function () {
  // Marks product-card headings whose title the 2-line clamp actually clips, so
  // component-card-bedrock.css shows the hover tooltip on those alone. Without the
  // measurement every card would sprout a popup on hover, including the ones whose
  // title already fits — a shadowed box over the price saying what is already said.
  // CSS cannot ask "is this element overflowing", hence the pass in script.
  //
  // Measured on hover rather than at load, because a hidden element has no
  // geometry: everything inside the closed mega-menu dropdown reports
  // scrollHeight === clientHeight === 0 and reads as "fits" no matter how long the
  // title is. A load-time sweep got this exactly backwards on a 187-character
  // title. Hovering guarantees the element is visible at the moment we measure, and
  // it also covers the cases a one-shot pass would miss for free — collection
  // filtering re-rendering the grid, bedrock-tabs.js cloning New Arrivals cards from
  // <template>, quick-add injecting markup, and resize reflowing the clamp.
  if (window.__bedrockCardTitles) return;
  window.__bedrockCardTitles = true;

  function measure(heading) {
    const title = heading.querySelector('.bedrock-card__title');
    if (!title) return;

    // 1px of slack: sub-pixel line heights push scrollHeight a fraction past
    // clientHeight on titles that are not actually clipped.
    heading.classList.toggle(
      'bedrock-card__heading--truncated',
      title.scrollHeight > title.clientHeight + 1
    );
  }

  function onEnter(event) {
    const heading = event.target.closest?.('.bedrock-card__heading');
    if (heading) measure(heading);
  }

  // Re-measured on every enter rather than cached: the reads are two properties,
  // and the answer changes with viewport width and with the web font swapping in.
  document.addEventListener('pointerover', onEnter);
  document.addEventListener('focusin', onEnter);
})();
